import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context) {
	var base = '.b-cardInfoSlider';

	$(base, context).each(function(i, el){
		var items = $(el).find(base + '-item');

		new Swiper (el.querySelector('.b-cardInfoSlider-container'), {
			slidesPerView: 'auto',
			spaceBetween: 16,
			watchOverflow: true,
			loop: items.length > 5 ? true : false,
			slideClass: 'b-cardInfoSlider-item',
			autoplay: {
				delay: 5000,
			},
		});
	});
});
